
import axios from 'axios'
// import env from '../lib/env'
export const config = { baseURL: process.env.REACT_APP_API_URL }
export const netconfig = { baseURL: process.env.REACT_APP_AUTH_URL }

// if (env.isDevelopment) {
//   // config.baseURL = 'http://192.168.0.8:8010/api/'
//   // config.baseURL = 'http://195.174.192.206:85/ords/webshop/'
//   // config.baseURL = 'https://rbalv820204.bas.roche.com:8443/ords/webshop/' // localhost:85
//   config.baseURL = 'http://85.98.209.189:85/ords/webshop/'

// }
// if (env.isProduction) {
//   // config.baseURL = 'http://localhost:8080/'
//   config.baseURL = 'http://85.98.209.189:85/ords/webshop/'
//   // config.baseURL = 'https://rbalv820204.bas.roche.com:8443/ords/webshop/' // localhost:85
// }

const api = axios.create(config)
const netapi = axios.create(netconfig)
export default api
